import React from 'react'
import PayUFinanceLogo from '../assets/img/payufinance_logo.svg'
import LoginIcon from '../assets/img/login_icon.svg'

function Header(props) {
  return (
    <>
    <section>
        <div className='comp-header'>
        <div className='container'>
            <div className='header-inner'>
            <div className='logo'>
                {/* <a href={DOMQuad}> */}
                    <img src={PayUFinanceLogo} alt='PayU Finance logo' className='img-fluid'/>
                    {/* </a> */}
            </div>
            
            <div className='menu-bar-actions-panel'>
            <a href={process.env.REACT_APP_LOGIN_URL}>
                <div className="item small-text">
                    <img src={LoginIcon} alt="loginIcon"/><span>Login</span>
                </div>
            </a>
            </div>
            </div>
        </div>
       </div>
    </section>
    </>
  )
}

export default Header